<template>
  <TheFooter>
    <div>
      <!--footer-->
      <a target="_blank" href="https://www.ndns.in/save-trees-app/">Save Trees</a>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Created by</span>
      <a href="https://www.ndns.in/" target="_blank">New Delhi Nature Society</a>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="http://leopardtechlabs.com" target="_blank">Leopard Tech Labs Pvt. Ltd</a>
    </div>
  </TheFooter>
</template>
<script>
import { Footer as TheFooter } from "@coreui/vue";
export default {
  name: "DefaultFooter",
  components: {
    TheFooter
  }
};
</script>
